export default __webpack_public_path__ + "static/media/fac-production-ban.7281b55b.jpg";